import { Component, OnInit } from '@angular/core';
import { LocalizerService } from '../services/localizer.service';
import { delay } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'localizer-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public url: string;
  public platforms: any;
  public invalid: boolean;
  public loading: boolean;
  public error: boolean;

  constructor(public localizer: LocalizerService) {
    this.url = '';
    this.platforms = [];
    this.invalid = true;
    this.loading = false;
    this.error = false;
    this.localizer.availablePlatforms.forEach(platform => {
      this.platforms.push({
        key: platform.key,
        name: platform.name,
        disabled: platform.disabled,
        checked: false
      });
    });
  }

  ngOnInit() {}

  public checkValidity(): void {
    if (!this.url) {
      this.invalid = true;
      return;
    } else if (!this.platforms.find((platform: any) => platform.checked)) {
      this.invalid = true;
      return;
    } else {
      this.invalid = false;
    }
  }

  public localize(): void {
    this.error = false;
    const started = Date.now();
    this.loading = true;
    const requestedPlatforms: string[] = [];
    this.platforms.forEach((value: any) => {
      if (value.checked) {
        requestedPlatforms.push(value.key);
      }
    });

    this.localizer.localize(requestedPlatforms.join(','), this.url).subscribe(
      zip => {
        const remaining = 2500 - ((Date.now() - started) % 2000);
        of(zip).pipe(delay(remaining)).subscribe(data => {
          const downloadURL = window.URL.createObjectURL(data);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'localization.zip';
          link.click();
          this.loading = false;
        });
      },
      () => {
        const remaining = 2500 - ((Date.now() - started) % 2000);
        of(true).pipe(delay(remaining)).subscribe(data => {
          this.loading = false;
          this.error = true;
        });
      }

    );
  }
}
